// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-K":"K_NA_outdoor-recreation-K__AfFa1"};